import axios from 'axios';

export const SessionService = {
  async SessionClose() {
    const res = await axios.post('/session/logout', {});

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
  async getSessions({ page, perPage }) {
    const res = await axios.get('mobile/users/sessions/', {
      params: {
        page,
        size: perPage,
      },
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
};
